import { useTranslation } from 'react-i18next';
import { OrgAvatar } from '@/shared/components/custom/avatars/OrgAvatar';
import { NotificationCard } from '@/shared/components/custom/notification-card/NotificationCard';
import type { MyInvitation } from '../types';

interface InvitationCardProps {
  invitation: MyInvitation;
  onOpen: () => void;
}

export function InvitationCard({ invitation, onOpen }: InvitationCardProps) {
  const { t } = useTranslation('invitations');

  return (
    <NotificationCard
      avatar={
        <OrgAvatar
          name={invitation.tenantName}
          color="indigo-nebula"
          src={invitation.tenantAvatarUrl ?? undefined}
          size="sm"
        />
      }
      title={t('card.title', { orgName: invitation.tenantName })}
      subtitle={t('card.subtitle', {
        inviterName: invitation.inviterName ?? invitation.tenantName,
        role: invitation.role,
      })}
      timestamp={invitation.createdAt}
      isRead={false}
      onClick={onOpen}
      testId={`invitations-card-${invitation.id}`}
    />
  );
}
